import paper from 'paper';
import { extractSvgLeavesViaDOM } from './extract-svg-leaves-dom';
import { MAX_DIMENSION } from '@/constants/editor';

export async function importSvgFile(file, { onProjectChange, updateTransformUI, viewMode, theme = 'dark' } = {}) {
  if (!file) return null;

  const svgString = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve(e.target.result);
    reader.onerror = reject;
    reader.readAsText(file);
  });

  if (!paper.project || !paper.view) {
    throw new Error('Paper.js проєкт не ініціалізовано');
  }

  paper.project.deselectAll();

  const fileName = (file.name.replace(/\.[^/.]+$/, '') || 'SVG Import').trim();

  const { items } = extractSvgLeavesViaDOM(svgString);

  if (items.length === 0) {
    throw new Error('SVG не містить видимих елементів');
  }

  const isVector = viewMode === 'vector';
  const applyVectorStyles = (item) => {
    if (item instanceof paper.Group) {
      item.children?.forEach(applyVectorStyles);
      return;
    }
    
    if (isVector) {
      if (!item.data) item.data = {};
      const type = item.data?.type;
      const isText = item instanceof paper.PointText;
      
      if (type || isText) {
        const isLineOrArrow = type === 'line' || type === 'arrow';
        const isArrowHead = item.closed && type === 'arrow';
        
        item.data.origStyle = {
          fillColor: isText ? '#888888' : (isLineOrArrow ? (isArrowHead ? '#000000' : null) : '#d59029'),
          strokeColor: isText ? '#888888' : '#000000',
          strokeWidth: isText ? 1.5 : 1,
          strokeScaling: item.strokeScaling !== undefined ? item.strokeScaling : isText
        };
      } else {
        item.data.origStyle = {
          fillColor: item.fillColor ? (item.fillColor.alpha === 0 ? 'transparent' : item.fillColor.toCSS(true)) : null,
          strokeColor: item.strokeColor ? item.strokeColor.toCSS(true) : null,
          strokeWidth: item.strokeWidth,
          strokeScaling: item.strokeScaling
        };
      }
      item.fillColor = new paper.Color(0, 0, 0, 0.001);
      item.strokeColor = theme === 'dark' ? '#cbd5e1' : '#334155';
      item.strokeWidth = 1 / paper.view.zoom;
      item.strokeScaling = false;
    }
  };

  const activeLayer = paper.project.activeLayer;
  const wrapper = new paper.Group({ insert: false });
  items.forEach((item) => {
    applyVectorStyles(item);
    wrapper.addChild(item);
  });

  const bounds = wrapper.bounds;
  if (bounds.width > 0 && bounds.height > 0) {
    const maxSize = Math.max(bounds.width, bounds.height);
    if (maxSize > MAX_DIMENSION) {
      wrapper.scale(MAX_DIMENSION / maxSize);
    }
  }
  activeLayer.addChild(wrapper);
  wrapper.position = paper.view.center;

  const finalItems = wrapper.removeChildren();
  finalItems.forEach((item, idx) => {
    activeLayer.addChild(item);
    if (!item.name) item.name = `${fileName}_${idx + 1}`;
    item.locked = false;
    item.selected = true;
  });
  wrapper.remove();
  paper.view.update();

  if (typeof updateTransformUI === 'function') updateTransformUI();
  if (typeof onProjectChange === 'function') onProjectChange();

  return finalItems;
}